const { combineReducers } = require('@reduxjs/toolkit');

import mccReducer from './mcc.slice';
import lpReducer from './loyalty-points.slice';

const conversionRatesReducer = combineReducers({
  mcc: mccReducer,
  loyaltyPoints: lpReducer,
});

export default conversionRatesReducer;
